import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { usePressFeedbackClick } from '../hooks/usePressFeedbackClick.js';
import { cx } from '../utils/cx.js';
import styles from './Anchor.module.css';

export type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  size?: 'xs' | 'sm' | 'md';
  children: ReactNode;
};

export function Anchor({ size = 'sm', className, children, onClick, ...rest }: AnchorProps) {
  const { onClick: pressOnClick, pressAttrs } = usePressFeedbackClick(onClick, {
    deferHostDefault: true,
  });
  return (
    <a
      className={cx(styles.anchor, styles[`size_${size}`], className)}
      onClick={pressOnClick}
      {...pressAttrs}
      {...rest}
    >
      {children}
    </a>
  );
}
